import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '@cityelectricalfactors/ui-components';
import VideoPlaceholder from './video_placeholder';
import VideoPlayer from './video_player';

const VideoModal = ({
  images,
  icon,
  video,
  captions,
  img_width: imgWidth,
  img_height: imgHeight,
  video_width: videoWidth,
  video_height: videoHeight,
}) => {
  const [isModalOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);

  const closeModal = () => setModalIsOpen(false);

  return (
    <>
      <VideoPlaceholder
        images={images}
        icon={icon}
        onClick={openModal}
        width={imgWidth}
        height={imgHeight}
      />
      <ModalComponent isOpen={isModalOpen} closeModal={closeModal}>
        <VideoPlayer
          video={video}
          captions={captions}
          onClick={closeModal}
          width={videoWidth}
          height={videoHeight}
        />
      </ModalComponent>
    </>
  );
};

const ModalComponent = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: rgba(0, 0, 0, 0.7);
  @media (min-width: 768px) {
    align-items: center;
  }
  & div {
    position: relative;
    width: 100%;
    max-width: 820px;
    margin: 112px 20px 0 20px;
    padding: 0;
    background-color: transparent;
    @media (min-width: 768px) {
      margin: 0 20px;
    }
  }
`;

export default VideoModal;
